import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { getPreference, setPreference } from '../services/angular-bridge';

// Angular Preferences.TAG_RELATED key — same cookie pref the Angular add-tag used.
const TAG_RELATED_PREF = 'tr';

/**
 * "Tag Related" / "Apply to Related" toggle, shared by every Add Tag control (grids +
 * viewer). Persisted via PreferenceService so it survives navigation and reloads.
 * `undefined` until first read — the injector isn't ready at module eval.
 */
interface TagRelatedState {
  tagRelated: boolean | undefined;
  setTagRelated: (v: boolean) => void;
}

export const useTagRelatedStore = create<TagRelatedState>()(
  immer((set) => ({
    tagRelated: undefined,
    setTagRelated: (v) => {
      setPreference(TAG_RELATED_PREF, v);
      set((s) => {
        s.tagRelated = v;
      });
    },
  }))
);

export function useTagRelated(): [boolean, (v: boolean) => void] {
  const stored = useTagRelatedStore((s) => s.tagRelated);
  const setTagRelated = useTagRelatedStore((s) => s.setTagRelated);
  return [stored ?? getPreference<boolean>(TAG_RELATED_PREF) ?? false, setTagRelated];
}
